import { useMemo } from 'react';
import { useIsManager } from '@axo/shared/data-access/provider';
import { MenuNode } from './menuNode';
import { useBucketsNodes } from './useBucketsNodes';
import { useMyLocksNodes } from './useMyLocksNodes';
import { useMyPortfolioNodes } from './useMyPortfolioNodes';
import { useOpenApplicationsNodes } from './useOpenApplicationsNodes';
import { useRecentApplicationsNodes } from './useRecentApplicationsNodes';
import { useWorkingListsNodes } from './useWorkingListsNodes';
import { useWorkQueueNodes } from './useWorkQueuesNodes';
import styles from './styles.module.css';
import { useShouldUseBuckets } from '../../../hooks/utils/useShouldUseBuckets';

export function useApplicationsNodes(marketCountry: string): MenuNode[] {
  const shouldUseBuckets = useShouldUseBuckets();

  const isManager = useIsManager();

  const workQueue = useWorkQueueNodes(marketCountry);
  const workingLists = useWorkingListsNodes(marketCountry);
  const buckets = useBucketsNodes(marketCountry);
  const openApplications = useOpenApplicationsNodes(marketCountry);
  const myPortfolio = useMyPortfolioNodes();
  const myLocks = useMyLocksNodes(marketCountry);
  const recentApplications = useRecentApplicationsNodes(marketCountry);

  return useMemo(
    () => [
      {
        id: '3E15102B-1F4B-406D-B169-0743A39FB68A',
        label: 'Applications',
        icon: 'folder-open',
        hasCaret: true,
        className: styles.clickable,
        childNodes: [
          ...(shouldUseBuckets ? workQueue : []),
          ...workingLists,
          ...(isManager && shouldUseBuckets ? buckets : []),
          ...openApplications,
          ...myPortfolio,
          ...myLocks,
          ...recentApplications,
        ],
      },
    ],
    [
      shouldUseBuckets,
      isManager,
      workQueue,
      workingLists,
      buckets,
      openApplications,
      myPortfolio,
      myLocks,
      recentApplications,
    ],
  );
}
